<template>
  <div class="shoppingDetelis">
    <navigator title="园区商城"></navigator>
    <van-swipe :autoplay="7000">
      <van-swipe-item  v-for="(item, index) in productInfo.thumb" :key="index">
        <img :src="item.img" class="imgPic">
      </van-swipe-item>
    </van-swipe>
    <div class="productInfoBox">
      <div class="productTitle">{{productInfo.productName}}</div>
      <div class="productInfo">
        <p class="productInfoText" v-for="(item,index) in extra" :key="index">
          {{item.attr}} : {{item.value}}
        </p>
      </div>
      <div class="productPrice">价格: ￥ {{productInfo.price / 100 | PriceFilter}}</div>
    </div>
    <div class="merchants">
      <div class="Title">商家名称</div>
      <div class="merchantsName">{{productInfo.createCorpName}}</div>
    </div>
    <div class="content">
      <div class="Title">商品详情</div>
      <div class="detalisText" v-html="productInfo.content"></div>
    </div>
    <div class="submit">
      <mt-button type="danger" class="submitButton" @click="submit">联系商家</mt-button>
    </div>
    <!-- <van-dialog v-model="show" @confirm="onConfirm">
      <van-field v-model="remark" label="附言" type="textarea" placeholder="请输入附言" rows="1" autosize/>
    </van-dialog> -->
    <van-dialog v-model="show" title='附言' show-cancel-button @cancel='cancel' @confirm='confirm'>
      <van-field v-model="remark" label="附言" placeholder="请输入附言"/>
    </van-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { Toast } from 'vant';

export default {
  data() {
    return{
      productInfo: {},
      extra: [],
      remark: '',
      show: false,
    }
  },
  methods: {
    getinfo() {
      this.$http.post(`${this.URL_PREFIX}/app/get/shop/products/detail`, {
        categoryId: this.$route.query.categoryId,
        id: this.$route.query.id,
        parkId: this.currentParkId,
      }).then((res) => {
        this.productInfo = res.data.resData.pageInfo;
        this.extra = res.data.resData.pageInfo.extra;
      });
    },
    submit() {
      if (!this.token) {
        this.$root.eventHub.$emit('login', this.$route.fullPath);
      } else {
        this.show = true;
      }
    },
    confirm() {
      this.show = false;
      if(this.remark !== '') {
        this.$http.post(`${this.URL_PREFIX}/app/added/shop/order`, {
          parkId: Number(this.currentParkId),
          productId: Number(this.$route.query.id),
          remark: this.remark,
        },{
          headers: { token: this.token, },
        }).then((res) => {
          if (res.data.resCode === '10000') {
            Toast.success('联系成功，请等待审批!');
            this.remark = '';
          }else {
            Toast.fail(res.data.resDesc);
          }
        });
      }else{
        Toast.fail('请填写附言');
      }
    },
    cancel() {
      this.remark = '';
    },
  },
  created() {
    // console.log(this.$route);
    this.getinfo();
  },
  computed: {
    ...mapGetters(['currentParkId', 'token']),
  },
}
</script>
<style lang="scss" scoped>
.imgPic{
  width: 100%;
  height: 10rem;
}
.productInfoBox{
  width: 100%;
  height: 3.866667rem;
  padding: .32rem;
  background-color: #fff;
  box-sizing: border-box;
  .productTitle{
    font-size: .453333rem;
    color: rgb(51, 51, 51);
    font-weight: bold;
  }
  .productInfo{
    margin-top: .266667rem;
    .productInfoText{
      font-size: .32rem;
      color: rgb(102, 102, 102);
      margin-top: .133333rem;
    }
  }
  .productPrice{
    font-size: .4rem;
    color: rgb(217, 38, 44);
    margin-top: .266667rem;
    font-weight: bold;
  }
}
.merchants{
  margin-top: .133333rem;
  background-color: #fff;
  width: 100%;
  .merchantsName{
    font-size: .4rem;
    color: rgb(51, 51, 51);
    padding: .293333rem .32rem;
  }
}
.content{
  margin-top: .133333rem;
  background-color: #fff;
  width: 100%;
  .detalisText{
    padding: .32rem .293333rem;
    font-size: .4rem;
    color: rgb(51, 51, 51);
  }
}
.Title{
  padding: .36rem .32rem;
  font-size: .453333rem;
  color: rgb(51, 51, 51);
  font-weight: bold;
  border-bottom: 1px solid rgb(245, 245, 245);
}
.submit{
  height: 1.32rem;
  background-color: rgb(235, 235, 235);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  .submitButton{
    width: 9.146667rem;
    height: 1.04rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shoppingMall/components/ShoppingDetelis.vue